import { ReactElement } from 'react';

import Button from '../../../Button/Button';
import Grid from '../../../Grid/Grid';
import { AlignItems } from '../../../Grid/Grid.types';
import { IActionBarProps } from './ActionBar.types';

const ALIGNMENT = {
  left: 'start',
  center: 'center',
  right: 'end',
};

const ActionBar = ({
  showPrimaryAction = true,
  showSecondaryAction = true,
  primaryActionLabel = 'Ok',
  secondaryActionLabel = 'Cancel',
  actionBarAlignment = 'right',
  onPrimaryActionClick,
  onSecondaryActionClick,
  onPrimaryActionProps,
  onSecondaryActionProps,
}: IActionBarProps): ReactElement => (
  <Grid
    gap={showPrimaryAction ? '12px' : '0'}
    columns="repeat(2, auto)"
    minRowHeight="auto"
    justifyContent={ALIGNMENT[actionBarAlignment] as AlignItems}
  >
    {showSecondaryAction && (
      <Button variant="outlined" size="small" onClick={onSecondaryActionClick} {...onSecondaryActionProps}>
        {secondaryActionLabel}
      </Button>
    )}
    {showPrimaryAction && (
      <Button onClick={onPrimaryActionClick} size="small" {...onPrimaryActionProps}>
        {primaryActionLabel}
      </Button>
    )}
  </Grid>
);

export default ActionBar;
